import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: "https://micervesa.advantacloud.com/graphql",
  headers: {
    authorization: "Bearer 661008be40f24c67ae487aa942f9835",
  },
});
